import { __rest, __awaiter, __generator, __assign } from 'tslib';
import React__default, { useEffect } from 'react';
import { useTheme } from '@mui/material';
import clsx from 'clsx';
import { useSpring, animated } from 'react-spring';
import DefaultIcon from '../../DefaultIcon/index.js';
import StyledKFavoriteButton, { classes } from './index.styled.js';

var KFavoriteButton = function (_a) {
    var _this = this;
    var _b = _a.testId, testId = _b === void 0 ? "KFavoriteButton" : _b, className = _a.className, _c = _a.active, active = _c === void 0 ? false : _c, title = _a.title, _d = _a.onClick, onClick = _d === void 0 ? function () { } : _d, _e = _a.visualHelper, visualHelper = _e === void 0 ? false : _e, _f = _a.visible, visible = _f === void 0 ? true : _f, _g = _a.KIcon, KIcon = _g === void 0 ? DefaultIcon : _g, rest = __rest(_a, ["testId", "className", "active", "title", "onClick", "visualHelper", "visible", "KIcon"]);
    var theme = useTheme();
    var rootClassName = clsx("KFavoriteButton", 
    // Integration or test purpose
    active && "KFavoriteButton-active", className);
    var fade = useSpring({
        opacity: visible ? 1 : 0,
        config: {
            duration: theme.transitions.duration.shortest
        }
    });
    var _h = useSpring(function () { return ({
        scale: visible ? 1 : 0.5
    }); }), pop = _h[0], popApi = _h[1];
    useEffect(function () {
        if (active) {
            popApi.start({
                to: function (next) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, next({ scale: 1.2 })];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, next({ scale: 1 })];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); },
                config: {
                    duration: theme.transitions.duration.shortest
                }
            });
        }
        return function () {
            popApi.start({ scale: 1 });
        };
    }, [visible, active, popApi, theme.transitions.duration.shortest]);
    var children = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", null),
        React__default.createElement("span", null),
        React__default.createElement(KIcon, { fontSize: "small", className: active
                ? "".concat(classes.icon, " fa-solid fa-star-sharp")
                : "".concat(classes.icon, " fa-light fa-star-sharp") })));
    if (visualHelper) {
        React__default.createElement(animated.div, { style: __assign(__assign({}, fade), pop), "data-testid": testId, className: rootClassName }, children);
    }
    return (React__default.createElement(StyledKFavoriteButton, __assign({ "data-testid": testId, className: rootClassName, title: title, "aria-label": title, onClick: function (e) { return onClick(e); }, style: __assign(__assign({}, fade), pop) }, rest), children));
};

export { KFavoriteButton as default };
//# sourceMappingURL=index.js.map
